import {parseGaClientId} from "./parse-ga-client-id";

/**
 * Client-side counterpart to `getGaClientId()` (`ga-client-id.ts`) — reads
 * the same `_ga` cookie directly from `document.cookie` instead of Next's
 * server-only `cookies()`, so it can run in the Mixpanel client SDK's init
 * path (see `initMixpanelClient`'s `identifyWithGaClientId` option).
 *
 * Unlike the server version, this does *not* fall back to a random UUID
 * when the cookie is absent — a client-generated fallback id would itself
 * diverge from whatever the server computes on the next request (which
 * *does* fall back, independently), reintroducing the same identity split
 * this is meant to close. Callers should skip identifying when this
 * returns `null` and let the SDK keep its own anonymous id for the session.
 */
export function getGaClientIdFromBrowserCookie(): string | null {
	const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
	if (!match?.[1]) {
		return null;
	}
	return parseGaClientId(decodeURIComponent(match[1]));
}
